import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    semanteer: '',
    sl: false,
    ui: false,
    vui: false,
    monitoring: false,
    console: false,
    solr: false,
    mcf: false
  },
  mutations: {
    updateState (state) {
      // check sl
      Vue.http.get('/sl/version')
        .then(response => {
          state.semanteer = response.data
          state.sl = true
        }, (error) => {
        // this.handleError(error);
        })

      // check ui
      Vue.http.get('/ui/')
        .then(response => {
          state.ui = true
        }, (error) => {
          // this.handleError(error);
        })

      // check vui
      Vue.http.get('/vui/')
        .then(response => {
          state.vui = true
        }, (error) => {
          // this.handleError(error);
        })

      // check monitoring
      Vue.http.get('/monitoring/')
        .then(response => {
          state.monitoring = true
        }, (error) => {
          // this.handleError(error);
        })

        // check console
        Vue.http.get('/console/')
          .then(response => {
            state.console = true
          }, (error) => {
            // this.handleError(error);
          })

      // check solr
      Vue.http.get('/solr/')
        .then(response => {
          state.solr = true
        }, (error) => {
          // this.handleError(error);
        })

      // check mcf
      Vue.http.get('/mcf-crawler-ui/login.jsp')
        .then(response => {
          state.mcf = true
        }, (error) => {
          // this.handleError(error);
        })
    }
  },
  actions: {

  }
})
